import React, { useEffect } from "react";
import { connect } from "react-redux";
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import TextareaAutosize from "@mui/material/TextareaAutosize";
import CurrencyFormatter from "currency-formatter";
import { generateDCFAnalysis, updateDCFAnalysis } from "../../../../store/modules/dealOffer/actions";
import BVAInput from "../../../../components/BVAInput/BVAInput";
import { rowStyle } from "../../../Dashboard/customStyles";
import YearBar from "../YearBar";
import Subtitle from "../Subtitle";
import Item from "../Item";

function DCFAnalysis({
  dealDCFAnalysis,
  dispatchGenerateDCFAnalysis,
  dispatchUpdateDCFAnalysis,
}) {
  // Mounted
  useEffect(() => {
    dispatchGenerateDCFAnalysis();
  }, []);

  const handleChange = (type, value, index = 0, id = 0) => {
    dispatchUpdateDCFAnalysis(type, value, index, id);
  };

  return (
    <div>
      {dealDCFAnalysis &&
        (<div className="pt-5">

          <YearBar data={dealDCFAnalysis.yearsFormatted} />

          <Subtitle title="Cash Flow to the Firm" length={dealDCFAnalysis.yearsFormatted.length} />
          <Item name="Free Cash Flow to the Firm" data={dealDCFAnalysis.FCFtoFirm} />
          {/* Synergies and Growth */}
          <div className="flex items-center mt-2">
            <div className="flex items-center" style={{ minWidth: "18em" }}>
              <div className="mr-10">Synergies</div>
              <FormControl variant="standard" sx={{ m: 1, minWidth: 80 }}>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  value={dealDCFAnalysis.synergiesType}
                  onChange={(e) => handleChange("Selection", e.target.value)}
                >
                  <MenuItem value={"Fixed"}>Fixed</MenuItem>
                  <MenuItem value={"Variable"}>Variable</MenuItem>
                  <MenuItem value={"Manual"}>Manual</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div className="flex">
              {dealDCFAnalysis.synergiesAndGrowth?.map((obj) => (
                <div className="flex" style={{ minWidth: "10em" }}>
                  <div style={{ minWidth: "1.8em" }} />
                  {CurrencyFormatter.format(obj?.value, { code: "USD" })}
                </div>
              ))}
            </div>
          </div>
          {/* Variable part of Synergies and Growth */}
          {dealDCFAnalysis.synergiesType === "Variable" &&
            (<div className="flex items-center">
              <div className="flex items-center" style={{ minWidth: "18em" }}>Synergies Rate</div>
              <div className="flex">
                {dealDCFAnalysis.variableSynergiesRateSeries.map((value, index) => (
                  <div className="flex items-center" style={{ width: "10em" }} key={index}>
                    <BVAInput
                      endAdornment
                      endAdornmentLabel="%"
                      textAlign="end"
                      width="95%"
                      size="small"
                      value={value}
                      onChange={(value) => handleChange("Series", value, index)}
                    />
                  </div>
                ))}
              </div>
            </div>)
          }
          {/* Manual part of Synergies and Growth */}
          {dealDCFAnalysis.synergiesType === "Manual" &&
            (<div>
              {dealDCFAnalysis.manualSynergiesRateMatrix.map((item, id) => (
                <div className="flex items-center mt-1" key={id}>
                  <div className="flex items-center" style={{ minWidth: "18em" }}>
                    <TextareaAutosize
                      style={rowStyle.tableItems}
                      aria-label="minimum height"
                      minRows={1}
                      maxRows={1}
                      defaultValue={item.name}
                      onBlur={(e) => handleChange("MatrixName", e.target.value, 0, id)}
                    />
                  </div>
                  <div className="flex">
                    {item.series.map((value, index) => (
                      <div className="flex items-center" style={{ width: "10em" }} key={index}>
                        <BVAInput
                          startAdornment
                          startAdornmentLabel="$"
                          textAlign="start"
                          width="95%"
                          size="small"
                          value={value}
                          onChange={(value) => handleChange("MatrixValue", value, index, id)}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>)
          }
          <Item name="Total Free Cash Flow to the Firm" data={dealDCFAnalysis.totalFCF} bold={true} />

          <Subtitle title="Total Deal Terms" length={dealDCFAnalysis.yearsFormatted.length} />
          <Item name="Earnout Compensation" data={dealDCFAnalysis.earnoutArray} />
          <Item name="Consulting Fee" data={dealDCFAnalysis.consultingArray} />
          <Item name="Deal Term Total Cash Expenses" data={dealDCFAnalysis.totalDebtTerm} bold={true} />

          <Subtitle title="Free Cash Flow Available for Debt Service" length={dealDCFAnalysis.yearsFormatted.length} />
          <Item name="Free Cash Flow Available" data={dealDCFAnalysis.FCFAvailable} bold={true} />

        </div>)
      }
    </div>
  );
}

const mapStateToProps = (state) => ({
  dealDCFAnalysis: state.dealOffer.dealDCFAnalysis,
});

const mapDispatchToProps = (dispatch) => ({
  async dispatchGenerateDCFAnalysis() {
    await dispatch(generateDCFAnalysis());
  },
  async dispatchUpdateDCFAnalysis(type, value, index, id) {
    await dispatch(updateDCFAnalysis(type, value, index, id));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(DCFAnalysis);
